import { createFileRoute, Outlet } from "@tanstack/react-router";
import { ErrorBoundaryComponent } from "#/components/error-boundary";

export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/lesson/$lesson",
)({
  component: () => <Outlet />,
  errorComponent: LessonError,
});

function LessonError({ error }: { error: unknown }) {
  const params = Route.useParams();
  return <ErrorBoundaryComponent error={error} params={params} />;
}
